module.exports = __webpack_public_path__ + "static/images/containers/Challenges/images/header-background.aeac7133.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/images/header-background.png
// module id = 2873
// module chunks = 11